import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type GetWorkflowRuleDefinitionByIdQueryVariables = GraphQLTypes.Exact<{
  workflowRuleDefinitionId: GraphQLTypes.Scalars['String']['input'];
}>;

export type GetWorkflowRuleDefinitionByIdQueryResult = { __typename?: 'Query' } & {
  workflowRuleDefinitionById: { __typename?: 'WorkflowRuleDefinitionType' } & Pick<
    GraphQLTypes.WorkflowRuleDefinitionType,
    'id' | 'ruleDefinitionTag' | 'ruleDescription' | 'ruleName'
  > & {
      defaultInput?: GraphQLTypes.Maybe<
        { __typename?: 'RuleInputObjectType' } & Pick<
          GraphQLTypes.RuleInputObjectType,
          | 'collectionCountry'
          | 'countryOfDestination'
          | 'countryOfOrigin'
          | 'deliveryCountry'
          | 'destination'
          | 'incoterms'
          | 'modeOfTransport'
          | 'origin'
          | 'portOfDestination'
          | 'portOfDestinationCountry'
          | 'portOfOrigin'
          | 'portOfOriginCountry'
          | 'shipmentContext'
          | 'shipmentType'
        > & {
            account?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'>>;
            event?: GraphQLTypes.Maybe<
              Array<GraphQLTypes.Maybe<{ __typename?: 'UserDefinedEventType' } & Pick<GraphQLTypes.UserDefinedEventType, 'id'>>>
            >;
            supplier?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'>>;
          }
      >;
      defaultOutput?: GraphQLTypes.Maybe<
        { __typename?: 'RuleOutputObjectType' } & {
          actions?: GraphQLTypes.Maybe<
            Array<{ __typename?: 'WorkflowAction' } & Pick<GraphQLTypes.WorkflowAction, 'label' | 'path' | 'type'>>
          >;
          consignee?: GraphQLTypes.Maybe<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'>>;
          consignor?: GraphQLTypes.Maybe<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'>>;
          customerOperationsCoordinator?: GraphQLTypes.Maybe<
            { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
          >;
          customsOperationsCoordinator?: GraphQLTypes.Maybe<
            { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
          >;
          destinationOperationsCoordinator?: GraphQLTypes.Maybe<
            { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
          >;
          notifyParties?: GraphQLTypes.Maybe<
            Array<{ __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'>>
          >;
          originAgent?: GraphQLTypes.Maybe<{ __typename?: 'Account' } & Pick<GraphQLTypes.Account, 'id'>>;
          originOperationsCoordinator?: GraphQLTypes.Maybe<
            { __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>
          >;
          supplierContacts?: GraphQLTypes.Maybe<Array<{ __typename?: 'AccountMember' } & Pick<GraphQLTypes.AccountMember, 'id'>>>;
        }
      >;
      ruleInputFields: Array<
        { __typename?: 'WorkflowRuleFieldType' } & Pick<
          GraphQLTypes.WorkflowRuleFieldType,
          'component' | 'hidden' | 'label' | 'name' | 'required'
        >
      >;
      ruleOutputFields: Array<
        { __typename?: 'WorkflowRuleFieldType' } & Pick<
          GraphQLTypes.WorkflowRuleFieldType,
          'component' | 'hidden' | 'label' | 'name' | 'required'
        >
      >;
    };
};

export const GetWorkflowRuleDefinitionByIdDocument = /*#__PURE__*/ gql`
  query getWorkflowRuleDefinitionById($workflowRuleDefinitionId: String!) {
    workflowRuleDefinitionById(workflowRuleDefinitionId: $workflowRuleDefinitionId) {
      defaultInput {
        account {
          id
        }
        collectionCountry
        countryOfDestination
        countryOfOrigin
        deliveryCountry
        destination
        event {
          id
        }
        incoterms
        modeOfTransport
        origin
        portOfDestination
        portOfDestinationCountry
        portOfOrigin
        portOfOriginCountry
        shipmentContext
        shipmentType
        supplier {
          id
        }
      }
      defaultOutput {
        actions {
          label
          path
          type
        }
        consignee {
          id
        }
        consignor {
          id
        }
        customerOperationsCoordinator {
          id
        }
        customsOperationsCoordinator {
          id
        }
        destinationOperationsCoordinator {
          id
        }
        notifyParties {
          id
        }
        originAgent {
          id
        }
        originOperationsCoordinator {
          id
        }
        supplierContacts {
          id
        }
      }
      id
      ruleDefinitionTag
      ruleDescription
      ruleInputFields {
        component
        hidden
        label
        name
        required
      }
      ruleName
      ruleOutputFields {
        component
        hidden
        label
        name
        required
      }
    }
  }
`;

/**
 * __useGetWorkflowRuleDefinitionByIdQuery__
 *
 * To run a query within a React component, call `useGetWorkflowRuleDefinitionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowRuleDefinitionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowRuleDefinitionByIdQuery({
 *   variables: {
 *      workflowRuleDefinitionId: // value for 'workflowRuleDefinitionId'
 *   },
 * });
 */
export function useGetWorkflowRuleDefinitionByIdQuery(
  baseOptions: Apollo.QueryHookOptions<GetWorkflowRuleDefinitionByIdQueryResult, GetWorkflowRuleDefinitionByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useQuery<GetWorkflowRuleDefinitionByIdQueryResult, GetWorkflowRuleDefinitionByIdQueryVariables>(
    GetWorkflowRuleDefinitionByIdDocument,
    options
  );
}
export function useGetWorkflowRuleDefinitionByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowRuleDefinitionByIdQueryResult, GetWorkflowRuleDefinitionByIdQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useLazyQuery<GetWorkflowRuleDefinitionByIdQueryResult, GetWorkflowRuleDefinitionByIdQueryVariables>(
    GetWorkflowRuleDefinitionByIdDocument,
    options
  );
}
export type GetWorkflowRuleDefinitionByIdQueryHookResult = ReturnType<typeof useGetWorkflowRuleDefinitionByIdQuery>;
export type GetWorkflowRuleDefinitionByIdLazyQueryHookResult = ReturnType<typeof useGetWorkflowRuleDefinitionByIdLazyQuery>;
